import { render, staticRenderFns } from "./ExternalAssessorDashboard.vue?vue&type=template&id=26ff11e8"
import script from "./ExternalAssessorDashboard.vue?vue&type=script&lang=js"
export * from "./ExternalAssessorDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports